import React, { useEffect, useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import firstImg from '../assets/images/bidd-first-im.webp';
import firstbg from '../assets/images/bidd-first-bg.webp';
import { setAnalyticsEvent } from '../../core/helpers/analytics';
import { initBranch, trackEvent } from '../../core/helpers/branchio';

const BiddFirstModal = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const shouldShow = localStorage.getItem("show_welcome_modal") === "true";
    if (shouldShow) {
      setShowModal(true);
    }
  }, []);

  const handleClose = () => {
    setShowModal(false);
    localStorage.removeItem("show_welcome_modal");
    setAnalyticsEvent("Bidd_Home_KYC_SKIP");
    initBranch().then(() => {
      trackEvent(`Bidd_Home_KYC_SKIP`);
    }).catch(error => console.error('Error initializing Branch:', error))
  };

  const handleCompleteKYC = () => {
    localStorage.removeItem("show_welcome_modal");
    setAnalyticsEvent("Bidd_Home_KYC_Complete");
    initBranch().then(() => {
      trackEvent(`Bidd_Home_KYC_Complete`);
    }).catch(error => console.error('Error initializing Branch:', error));
    window.location.href = `${process.env.REACT_APP_URL_ENDPOINTS}/profile?hv=true`;
  }

  return (
    showModal ? (
      <Modal isOpen={showModal} toggle={handleClose} centered className="bidd-first-modal">
        <style>{`.modal.fade.show { backdrop-filter: blur(20px); }`}</style>
        <ModalBody className="bidd-first-modal-body">
          <p className="bidd-heading">You’re Nearly There!</p>
          <div className="bidd-wrapper">
            <div className="bidd-texts">
              <p className="bidd-discount">
                Unlock <span className="highlight">0.25%</span> Discount On Your First Transaction!
              </p>

              <img src={firstImg} alt="First" />

            </div>
          </div>
          <div className="bidd-actions">
              <button className="bidd-skip" onClick={handleClose}>Later</button>
              <button className="bidd-cta" onClick={() => handleCompleteKYC()}>COMPLETE KYC</button>
            </div>
        </ModalBody>
      </Modal>
    ) : null
  );
};

export default BiddFirstModal;
